import { Text } from "@app/domains/shared/design-system";
import styled from "styled-components";

export const HelpText = styled(Text)`
  margin: 0 auto;

  font-size: ${({ theme }) => theme.fontSizes.m};
  text-align: center;
`;
